import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import BuyerSearchResults from './BuyerSearchResults';

const styles = (theme) => ({
  root: {
    borderRadius: 4,
    background: theme.palette.common.yellow,
    width: 640,
    padding: '8px 5px'
  },
  input: {
    color: theme.palette.primary,
    border: '0 none',
    padding: '2px 0px',
    '&::placeholder': {
      color: theme.palette.primary,
      opacity: 0.7
    }
  },
  icon: {
    color: theme.palette.primary,
    margin: '2px 2px 0px 0px'
  }
});

class BuyerSearch extends Component {

  constructor(props) {
    super(props);
    this.bar = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleShortcuts);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleShortcuts);
  }

  handleShortcuts = (evt) => {
    if (evt.ctrlKey && evt.key === 'f') {
      this.bar.current.focus();
    }
    if (evt.key === 'Escape') {
      this.props.onClose();
    }
  };

  render() {
    const {
      classes,
      query,
      results,
      selected,
      onChange,
      onSelect,
      onKeyDown
    } = this.props;

    const res = !!results ? results[query] : [];
    return (
      <div className={classes.root}>
        <TextField
          variant="standard"
          value={query}
          id="searchbar"
          inputRef={this.bar}
          onChange={onChange}
          onKeyDown={onKeyDown}
          InputProps={{
            classes: {
              root: classes.root,
              input: classes.input
            }
          }}
          autoFocus />
        <BuyerSearchResults
          results={res}
          selected={selected}
          onSelect={onSelect}
        />
      </div>
    );
  }
}

BuyerSearch.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(BuyerSearch);
